// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__VWgMt","input":"Checkbox_input__QX96x","inner":"Checkbox_inner__HHP-u","tick":"Checkbox_tick__avD9P","text":"Checkbox_text__MPGo0"};